import { render, staticRenderFns } from "./HomePartnerDetail.vue?vue&type=template&id=36bf522b&scoped=true"
import script from "./HomePartnerDetail.vue?vue&type=script&lang=ts"
export * from "./HomePartnerDetail.vue?vue&type=script&lang=ts"
import style0 from "./HomePartnerDetail.vue?vue&type=style&index=0&id=36bf522b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf522b",
  null
  
)

export default component.exports